import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { TextField, Button } from '@mui/material';
import { Remove } from '@mui/icons-material';

import ContentBox from '../layout/ContentBox';

type Props = {
  addresses: string[];
  onSave: (emails: string[]) => void;
};

type State = {
  addresses: string[];
}

class ForwardAddresses extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      addresses: ['', '', ''].map((__, idx) => props.addresses[idx] || ''),
    };
  }

  handleChange = (value: string, idx: number) => {
    this.setState({
      addresses: this.state.addresses.map((address, addressIndex) => (
        idx === addressIndex ? value : address
      )),
    });
  };

  doSave = () => this.props.onSave(this.state.addresses.filter((address) => address !== ''));

  renderEmailTextField = (idx: number) => (
    <div className="flex items-center pb3">
      <TextField
        label={`E-Mail ${idx + 1}`}
        name={`EmailAddress-${idx}`}
        sx={{ width: '100%' }}
        placeholder={this.state.addresses[idx]}
        value={this.state.addresses[idx]}
        onChange={(e) => this.handleChange(e.target.value, idx)}
        variant="outlined"
        size="small"
      />
      {
        this.state.addresses[idx] && (
          <div className="mh1">
            <Button
              variant="text"
              className="ml3"
              onClick={() => this.handleChange('', idx)}
              color="secondary"
              size="small"
            >
              <Remove fontSize="small" />
            </Button>
          </div>
        )
      }
    </div>
  );

  render() {
    return (
      <ContentBox title={<FormattedMessage id="account.forwardAddressesHeading" />}>
        <p><FormattedMessage id="account.forwardMailDescription" /></p>

        <div className="mw7">
          {this.renderEmailTextField(0)}
          {this.renderEmailTextField(1)}
          {this.renderEmailTextField(2)}
        </div>

        <div className="mt2">
          <Button
            variant="contained"
            onClick={this.doSave}
          >
            <FormattedMessage id="save" />
          </Button>
        </div>
      </ContentBox>
    );
  }
}

export default ForwardAddresses;
